import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiNoData = class PiNoData extends Vue {
};
__decorate([
    Prop({ default: "暂无数据" })
], PiNoData.prototype, "content", void 0);
__decorate([
    Prop({ default: true })
], PiNoData.prototype, "center", void 0);
PiNoData = __decorate([
    Component
], PiNoData);
export default PiNoData;
